import { PermissionsPanelCtrl } from '../controllers/PermissionsPanelCtrl';
import { Module } from '../Module';

Module.instance().directive('tbPermissionsPanel',
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'permissionsPanel.html',
      scope: {
        authorizableType: '=',
        authorizables: '=',
        templateType: '=',
        showPrompt: '='
      },
      controller: PermissionsPanelCtrl
    };
  }
);
